<template>
  <div>
    <div class="head" v-if="detail != false">
      <div class="title">
        <div class="item" v-for="(item, index) in detail.range" :key="index" :class="{ select: index == rangeIndex }"
          @click="toggleRange(item, index)">{{ item.tag }}</div>
      </div>
      <!-- 人员筛选 -->
      <div class="seach" v-if="isUser">
        <!--人员范围-->
        <div class="item" style="width: 400px;">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
        </div>
        <div class="item">
          <!--  全体人员-->
          <el-select v-model="filter_admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <div class="item">
          <el-button type="primary" @click="timeDurationMenu">{{ $t('message.search') }}</el-button>
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
      </div>
      <div class="tabs">
        <div class="item" v-for="(item, index) in detail.type" :key="index" :class="{ select: index == typeIndex }"
          @click="toggleType(item, index)">{{ item.tag }}</div>
      </div>
    </div>
    <!-- 无数据 -->
    <div v-else class="head">
      <div class="title"> 暂无数据</div>
    </div>
    <!-- 单个图标 -->
    <item v-if="show && toggleName != 'baseData'" :list="list" />
    <!-- 饼图 -->
    <pieItem v-if="show && toggleName == 'baseData'" :list="list" />
  </div>
</template>

<script>
import item from './item'
import pieItem from './pieItem/index'
export default {
  components: {
    item,
    pieItem,
  },
  data() {
    return {
      datas: {
        org_id: '',
      }, // 人员范围
      typeIndex: 0, // 订单类型
      rangeIndex: 0, // 统计分类
      detail: {}, // 数据
      show: false, // 先隐藏再展示 
      list: [],  //图标list
      userList: [], //全体人员
      filter_admin_id: '',//
      isUser: '',//是否显示人员筛选
      toggleName: '',
      lineArr: [],//折线图数组
    };
  },
  created() {
    this.timeDurationMenu()



  },
  methods: {
    // 插入折线图
    interposition(data) {
      let index = this.list.findIndex(item => item.tag == data.tag)
      this.list.splice(index, 0, data);
    },
    // 获取筛选项数据
    timeDurationMenu() {
      this.$api.timeDurationMenu().then(res => {
        this.detail = res.data
        if (res.data != false) {
          this.timeDuration()
        }
        console.log(res);
      })
    },
    // 获取图表数据
    timeDuration() {
      let datas = {
        type: this.detail.type[this.typeIndex].k,
        range: this.detail.range[this.rangeIndex].k,
        // type: 'order',
        // range: 'class',
        filter_admin_id: this.filter_admin_id
        // clearCache: 1
      }
      this.toggleName = this.detail.type[this.typeIndex].k
      this.show = false
      this.lineArr = []
      this.list = []
      this.$api.timeDuration(datas).then(res => {
        res.data.forEach(item => {
          item.time = 'week'
          item.days = 30
          item.years = '今年'
          item.months = '月'
          item.show = true
          item.option = {}
          item.pieOption = {}
          // 新增折线图
          if (item.week) {
            if (item.week[0].listMap) {
              let copyItem = JSON.parse(JSON.stringify(item))
              copyItem.type = 'line'
              this.lineArr.push(copyItem)
            }
          }
        })
        this.list = res.data


        // 插入数据
        this.lineArr.forEach(item => {
          this.interposition(item)
        })
        this.show = true

        console.log(this.list);
      })
    },
    // type切换
    toggleType(item, index) {
      this.typeIndex = index
      this.timeDuration()
    },
    // Range切换
    toggleRange(item, index) {
      this.rangeIndex = index
      if (item.tag == '组员统计') {
        this.isUser = true
      } else {
        this.filter_admin_id = ''
        this.isUser = false
        this.timeDuration()
      }

    },
    reset() {
      this.$refs.cascader.orgId = [];
      this.datas.org_id = ''
      this.filter_admin_id = ''
      this.userList = []
      this.timeDuration()
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.filter_admin_id = "";
    },
  }
}
</script>

<style>
.routerView {
  background-color: #f5f5f5 !important;
}
</style>

<style lang='scss' scoped>
.head {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 24px;
  padding: 24px;

  .title {
    margin-bottom: 24px;
    text-align: left;
    display: flex;


    .item {
      margin-right: 52px;
      cursor: pointer;
      padding-bottom: 12px;
      border: 0 !important;

    }
  }

  .tabs {
    display: flex;

    .item {
      margin-right: 52px;
      cursor: pointer;
      font-size: 16px;
      padding-bottom: 12px;

    }


  }

  .seach {
    display: flex;
    margin-bottom: 24px;

    .item {
      margin-right: 24px;
    }
  }

  .select {
    border-bottom: 2px solid #B4272D;
    color: #B4272D;
  }
}
</style>